import { Link } from "react-router-dom";

// Every job number is a link to that job's page (next upcoming visit, all visits listed).
export const JobNumberLink = ({ n, className = "", testid }) => {
  if (n == null) return null;
  return (
    <Link to={`/job-number/${n}`} onClick={(e) => e.stopPropagation()} data-testid={testid || `job-number-link-${n}`}
      className={`font-mono font-semibold text-brand underline-offset-2 hover:underline ${className}`}>
      #{n}
    </Link>
  );
};
